import hrms16xLabels from 'assets/labels/hrms16x'
import moment from 'moment'
import faker from 'faker'

export const mocker = {
  labels () {
    return {
      labels: hrms16xLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        kpino: faker.random.number().toString().substr(0, 1),
        kpiitem: 'KPI',
        target: 'เพื่อความเป็นเลิศ',
        dteapkpi: moment().format('DD/MM/YYYY'),
        actbedon: 'ทำ STA',
        desc_mtrunit: 'ค่าเฉลี่ย',
        mtrvalue: faker.commerce.price().substr(1, 5),
        mtrvalnet: faker.commerce.price().substr(1, 5)
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms16x/mocker.js